import React from 'react'
import Hero from './Hero/Hero'
import Page from '../../components/Page/Page'

const JoinWaitlist = () => {
    return (
        <Page title='CML | Join Waitlist'><Hero /></Page>
    )
}

export default JoinWaitlist